<template>
  <card title="Photo de profil">
    <template v-slot:card-title>
      <span class="card-title mb-16">Photo de profil</span>
    </template>
    <template v-slot:card-content>
      <edit-photo-form />
    </template>
  </card>
</template>
<script>
import Card from "@/components/base/card";
import EditPhotoForm from "./edit-photo-form";
export default {
  name: "profile",
  components: {
    Card,
    EditPhotoForm
  }
};
</script>
